// extracted by mini-css-extract-plugin
export default {"noResultsMessage":"noResultsMessage---SNu2G","noResultsMessageLabel":"noResultsMessageLabel---lkO_C"};